import { isAxiosError } from "axios"
import { StatusCodes } from "http-status-codes"

export function getErrorMessage(error: unknown, fallbackMessage: string): string {
  if (error instanceof Error && error.message && error.message !== fallbackMessage) {
    return `${fallbackMessage}: ${error.message}`
  }

  if (typeof error === "string" && error && error !== fallbackMessage) {
    return `${fallbackMessage}: ${error}`
  }

  return fallbackMessage
}

export function getApiErrorMessage(error: unknown, fallbackMessage: string): string {
  if (!isAxiosError(error) || error.response?.status !== StatusCodes.BAD_REQUEST) {
    return fallbackMessage
  }

  const data: unknown = error.response.data
  if (typeof data === "string") {
    return data ? `${fallbackMessage}: ${data}` : fallbackMessage
  }

  const body = (data ?? {}) as {
    errorMessage?: string
    detail?: string
    title?: string
    errors?: Record<string, string[]>
  }
  const validationErrors = body.errors ? Object.values(body.errors).flat().join(" ") : ""
  const detail = body.errorMessage || body.detail || validationErrors || body.title

  return detail ? `${fallbackMessage}: ${detail}` : fallbackMessage
}
